export const COMPOSER_STEPS = [
  {
    value: "recipients",
    label: "Recipients",
    title: "Who's this for?",
    subtitle: "Start from a common audience. You can fine-tune it after.",
  },
  {
    value: "sender",
    label: "Sender",
    title: "Who's it from?",
    subtitle: "This is what fans see in their inbox before they open it.",
  },
  {
    value: "content",
    label: "Content",
    title: "Pick a starting point",
    subtitle: "Pick a type of email and a template. It opens in the editor, where you can change anything.",
  },
  {
    value: "schedule",
    label: "Schedule",
    title: "When should it go out?",
    subtitle: "Check the list below, then hit send.",
  },
];

export const SMS_COMPOSER_STEPS = [
  {
    value: "recipients",
    label: "Recipients",
    title: "Who's this for?",
    subtitle: "Start from a common audience. Only fans who opted in to texts are included, unless you send it as a transactional message.",
  },
  {
    value: "message",
    label: "Message",
    title: "What's the message?",
    subtitle: "Keep it short. Texts over 160 characters are split and billed as more than one.",
  },
  {
    value: "schedule",
    label: "Schedule",
    title: "When should it go out?",
    subtitle: "Check the list below, then hit send.",
  },
];

export const composerSteps = (isSms) => (isSms ? SMS_COMPOSER_STEPS : COMPOSER_STEPS);

export const initialComposerStep = (search, isSms = false) => {
  const steps = composerSteps(isSms);
  const requested = new URLSearchParams(search).get("step");
  const known = steps.some((step) => step.value === requested);

  return known ? requested : steps[0].value;
};

export const completedComposerSteps = ({
  isSms = false,
  recipientsCount,
  emailSendDomain,
  selectedSendDomain,
  subject,
  templateHasContent,
  scheduledSend,
  twilioTemplate,
  messageDraft,
  messageErrors = [],
}) => {
  const recipients = Number(String(recipientsCount).replace(/,/g, "")) > 0;
  const schedule = Boolean(scheduledSend);

  if (isSms) {
    return {
      recipients,
      message: Boolean((messageDraft ?? twilioTemplate?.template)?.trim() && twilioTemplate?.twilio_messaging_service_id)
        && messageErrors.length === 0,
      schedule,
    };
  }

  return {
    recipients,
    sender: Boolean(emailSendDomain?.name && selectedSendDomain && subject),
    content: Boolean(templateHasContent),
    schedule,
  };
};

export const readyToSend = (completed, delivery, scheduledAt) => (
  Object.entries(completed).every(([step, done]) => step === "schedule" || done)
    && (delivery === "now" || Boolean(scheduledAt))
);
